module.exports = __webpack_public_path__ + "static/img/ic_down.dac2640b.svg";